<div class="d-flex border px-2 py-2 rounded mb-7 align-items-center">
  <!--begin::Symbol-->
  <div class="symbol symbol-50px me-5">
      <span class="symbol-label">
          <!-- <img [src]="space.logo" class="h-50 align-self-center" alt=""> -->
      </span>
  </div>
  <!--end::Symbol-->

  <!--begin::Section-->
  <div class="d-flex align-items-center flex-row-fluid flex-wrap">
      <div class="flex-grow-1 me-2">
          <!-- <a href="#" class="text-gray-800 text-hover-primary fs-6 fw-bold">{{space.name}}</a> -->

          <span class="text-muted fw-semibold d-block fs-7">Mark, Rowling, Esther</span>
      </div>


  </div>
  <!--end::Section-->
</div>
